import { Flex } from "rebass";
import { getLocalizedString } from "../../../utils";
import { BsChevronUp, BsChevronDown } from "react-icons/bs";
const SeasonBlock = ({
  showSeasonOptions,
  seasonOptions,
  openSeason,
  selectFilterSeasonOptions,
}) => {
  return (
    <>
      <Flex
        bg="#DEDEDE"
        height="40px"
        width="100%"
        style={{ borderBottom: "2px solid #d2d2d2" }}
        px="10px"
        alignItems="center"
        justifyContent="space-between"
        onClick={openSeason}
      >
        <span>{getLocalizedString("Stagione").toUpperCase()}</span>
        <div>{showSeasonOptions ? <BsChevronUp /> : <BsChevronDown />}</div>
      </Flex>
      <Flex flexDirection="column">
        {showSeasonOptions &&
          seasonOptions?.map((opt, i) => (
            <Flex
              key={i}
              height="40px"
              px="10px"
              alignItems="center"
              bg="#f2f2f2"
              mb="2px"
              onClick={() => selectFilterSeasonOptions(opt)}
            >
              <span>{opt.label}</span>
            </Flex>
          ))}
      </Flex>
    </>
  );
};

export { SeasonBlock };
